import { qq } from "../../helper/q"

export const ecommerceInit = () => {
  const elements = qq("[data-ecommerce]")
  elements.map(element => {
    element.addEventListener("click", () => {
      const productData = JSON.parse(element.dataset.ecommerce.replace(/'/g, '"'))
      if (typeof window.dataLayer !== "undefined") {
        window.dataLayer.map((item, index) => {
          if (item.hasOwnProperty("ecommerce")) {
            window.dataLayer[index] = {}
          }
        })
        window.dataLayer.push(productData)
      }
    })
  })
}
